"use client";

import { useMemo } from "react";

import { useNamespaceTasksQuery } from "@/hooks/useWorkspaceData";

import { buildPromptsFromTasks } from "./prompt-utils";

export function useAssistantPrompts(namespaceId: string | null) {
  const tasksQuery = useNamespaceTasksQuery(namespaceId ?? undefined, {
    state: "active",
  });

  return useMemo(() => {
    if (!namespaceId) {
      return [] as string[];
    }

    return buildPromptsFromTasks(tasksQuery.data?.tasks ?? []);
  }, [namespaceId, tasksQuery.data]);
}
